import React from 'react'
import useSWR from 'swr'
import { fetchSites, Site } from '../../services/api'
import { useWidgetSite } from '../../contexts/WidgetSiteContext'
import pageStyles from '../../styles/page.module.scss'
import styles from './SiteSelector.module.scss'

interface Props {
  children: React.ReactNode
}

const SiteSelector: React.FC<Props> = ({ children }) => {
  const { siteId, setSite } = useWidgetSite()
  const { data: sitesData } = useSWR('merch-sites', fetchSites, { revalidateOnFocus: false })
  const sites: Site[] = sitesData?.sites || []

  if (!siteId) {
    return (
      <div className={pageStyles.pageContainer}>
        <div className={styles.sitePickerContainer}>
          <h1>Merchandising</h1>
          <p>Select a site to manage widgets for:</p>
          <div className={styles.siteCards}>
            {sites.map(s => (
              <button key={s.id} className={styles.siteCard} onClick={() => setSite(s.id)}>
                <h2>{s.name}</h2>
                <p>{s.code}</p>
              </button>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default SiteSelector
